export default "__VITE_PUBLIC_ASSET__ca0503a5__"